class FloatToc {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const toggleNav = '.js-float-toc';

  $('.js-toc-toggle').each(function(index) {
    applyScrollTrigger($(this), index);
  });

  function applyScrollTrigger(toggleSection, index) {
    if($(toggleNav).length){
      gsap.to(toggleNav, { 
        scrollTrigger: {
          trigger: toggleSection,
          start: 'top center',
          onEnter: () => setNavItemActive(index),
          onEnterBack: () => setNavItemActive(index)
        },
      });
    }
  }

  function setNavItemActive(index) {
    $(toggleNav).find('li').removeClass('is-active');
    $(toggleNav).find('li').eq(index).addClass('is-active');
  }
  }
}